import { Injectable, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AppError } from '../types/app-error.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  private currentError = signal<AppError | null>(null);
  readonly error = this.currentError.asReadonly();

  handleHttpError(error: HttpErrorResponse): void {
    const appError: AppError = {
      code: error.status.toString(),
      message: this.getErrorMessage(error),
      details: error.message,
      timestamp: new Date()
    };

    this.currentError.set(appError);
    console.error('HTTP Error:', appError);
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'Sin conexión a internet. Verifique su conexión e intente nuevamente';
    }
    if (error.status >= 500) {
      return 'Error del servidor. Intente nuevamente más tarde';
    }
    if (error.status === 404) {
      return 'Recurso no encontrado';
    }
    if (error.status === 401) {
      return 'No autorizado. Inicie sesión nuevamente';
    }
    return error.error?.message || 'Ha ocurrido un error inesperado';
  }

  clearError(): void {
    this.currentError.set(null);
  }
}
